import { render, staticRenderFns } from "./BaikalSlider.vue?vue&type=template&id=6f4c265b"
import script from "./BaikalSlider.vue?vue&type=script&lang=js"
export * from "./BaikalSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports